import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { withTranslation, WithTranslation } from "react-i18next";
import * as AdaptiveCards from "adaptivecards";
import { app, dialog } from "@microsoft/teams-js";
import './sendConfirmationTaskModule.scss';
import { getDraftNotification, getConsentSummaries, sendDraftNotification, getCardTypes, getTemplate } from '../../apis/messageListApi';
import {
    getInitAdaptiveCard, setCardStyle, setCard
} from '../AdaptiveCard/adaptiveCard';
import { TFunction } from "i18next";
import { markDownToHtml } from '../../helpers/formattingHelper'
import { ICardTypeMetadata } from '../../cardTypes';
import { ITemplate } from '../../templateModel'
import {
    getInitIncidentAdaptiveCard, setAreaInvolved, setSeverity, setNetworkAffected, setAgencyAffected,
    setServiceImpact, setIssueStartTime, setIncidentCardTitle, setLatestUpdate, setActionsIncident
} from '../AdaptiveCard/incidentAdaptiveCard';
import moment from 'moment';
import { Button, Spinner, Link, Text, Persona } from "@fluentui/react-components"
import { INewsletter, INewsSection, prepareNewsTemplateCard } from '../NewMessage/newsTemplate';
import { elements } from 'chart.js';


export interface IListItem {
    header: string,
    media: JSX.Element,
}

export interface IAction {
    title: string,
    link: string
}

export interface IMessage {
    id: string;
    title: string;
    acknowledgements?: number;
    reactions?: number;
    responses?: number;
    succeeded?: number;
    failed?: number;
    throttled?: number;
    sentDate?: string;
    imageLink?: string;
    videoLink?: string;
    videoImageLink?: string;
    summary?: string;
    summary2?: string;
    author?: string;
    updateType: string;
    actions: IAction[];
    eventUrl?: string;
    incidentSeverity: string,
    areasInvolved: string[],
    networkAffected: string,
    agencyAffected: string,
    serviceImpact: string,
    incidentCardTitle: string,
    latestUpdate: string,
    latestUpdateDate?: Date,
    latestUpdateValue: string,
    issueStartTime?: Date,
    newsletterHeader?: string,
}

export interface SendConfirmationTaskModuleProps extends RouteComponentProps, WithTranslation {
}

export interface IStatusState {
    message: IMessage;
    loader: boolean;
    teamNames: string[];
    rosterNames: string[];
    groupNames: string[];
    userNames: string[];
    allUsers: boolean;
    messageId: number | string;
    usersListFile?: string,
    cardTypes: { [key: string]: ICardTypeMetadata }
    template: any;
}

class SendConfirmationTaskModule extends React.Component<SendConfirmationTaskModuleProps, IStatusState> {
    readonly localize: TFunction;
    private initMessage = {
        id: "",
        title: "",
        updateType: "",
        actions: [],
        incidentSeverity: "",
        areasInvolved: [],
        networkAffected: "",
        agencyAffected: "",
        serviceImpact: "",
        incidentCardTitle: "",
        latestUpdate: "",
        latestUpdateValue: "",
    };

    private card: any;
    private incidentCard: any;

    constructor(props: SendConfirmationTaskModuleProps) {
        super(props);
        this.localize = this.props.t;
        this.card = getInitAdaptiveCard(this.localize);
        this.incidentCard = getInitIncidentAdaptiveCard(this.localize);

        this.state = {
            message: this.initMessage,
            loader: true,
            teamNames: [],
            rosterNames: [],
            groupNames: [],
            userNames: [],
            allUsers: false,
            messageId: 0,
            usersListFile: undefined,
            cardTypes: {},
            template: null,
        };
    }

    public async componentDidMount() {
        await app.initialize();

        var cardTypesResponse = await getCardTypes();
        this.setState({ cardTypes: cardTypesResponse.data });

        let params = this.props.match.params;

        if ('id' in params) {
            let id = String(params['id']);
            await this.getItem(id);
            await this.getTemplate(this.state.message.updateType);
            let response = await getConsentSummaries(id);
            this.setState({
                teamNames: response.data.teamNames.sort(),
                rosterNames: response.data.rosterNames.sort(),
                groupNames: response.data.groupNames.sort(),
                userNames: response.data.userNames.sort(),
                allUsers: response.data.allUsers,
                usersListFile: response.data.usersListFile,
                messageId: id,
            }, () => {
                this.setState({
                    loader: false
                }, () => {
                    var card;
                    if (this.state.message.updateType === "010") {
                        card = this.incidentCard
                        setIncidentCardTitle(this.incidentCard, this.state.message.incidentCardTitle)
                        setSeverity(this.incidentCard, this.state.message.incidentSeverity)
                        setAreaInvolved(this.incidentCard, this.state.message.areasInvolved)
                        setNetworkAffected(this.incidentCard, this.state.message.networkAffected)
                        setAgencyAffected(this.incidentCard, this.state.message.agencyAffected)
                        setServiceImpact(this.incidentCard, this.state.message.serviceImpact)
                        setIssueStartTime(this.incidentCard, moment(new Date(this.state.message.issueStartTime!)).format("MM/DD/YYYY hh:mm A"))
                        setActionsIncident(this.incidentCard, this.state.message.actions)
                        var setDateOnCard = this.state.message.latestUpdateDate ? moment(new Date(this.state.message.latestUpdateDate!)).format("MM/DD/YYYY hh:mm A") : "Time will be set to Current Date";
                        if (this.state.message.latestUpdate.length > 0) {
                            setLatestUpdate(this.incidentCard, this.state.message.latestUpdate, setDateOnCard)
                        }
                    } else if (this.state.message.updateType === "999") {
                        const separator = "%%||";

                        const titles = this.state.message.title.split(separator);
                        const imageLinks = this.state.message.imageLink?.split(separator) || [];;
                        const summaries = this.state.message.summary?.split(separator) || [];
                
                        var sections = titles.map((title, index) => ({
                            title: title,
                            summary: summaries[index],
                            imageUrl: imageLinks[index]
                        } as INewsSection))
                
                        var letter = {
                            sections: sections,
                            header: this.state.message.newsletterHeader,
                            actions: this.state.message.actions
                        } as INewsletter

                        card = prepareNewsTemplateCard(letter)
                    } else {
                        card = this.card

                        setCard(this.localize, this.card, this.state.template.elements, this.state.template.textColor, this.state.message, this.state.template)
                    }


                    let adaptiveCard = new AdaptiveCards.AdaptiveCard();
                    AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
                        result.outputHtml = markDownToHtml(text);
                        result.didProcess = true;
                    };

                    adaptiveCard.parse(card);
                    let renderedCard = adaptiveCard.render() as HTMLElement;
                    document.getElementsByClassName('adaptiveCardContainer')[0].appendChild(renderedCard);
                    // if (this.state.message.buttonLink) {
                    //     let link = this.state.message.buttonLink;
                    //     adaptiveCard.onExecuteAction = function (action) { window.open(link, '_blank'); };
                    // }
                });
            });
        }
    }

    private getItem = async (id: string) => {
        try {
            const response = await getDraftNotification(id);
            this.setState({
                message: response.data
            });
        } catch (error) {
            return error;
        }
    }

    private getTemplate = async (id: string) => {
        try {
            let response = await getTemplate(id);
            const templateData = response.data;

            var newTemplate: ITemplate = {
                id: templateData.id,
                templateName: templateData.templateName,
                indexOrder: templateData.indexOrder,
                bannerUrl: templateData.bannerUrl,
                backgroundColorUrl: templateData.backgroundColorUrl,
                textColor: templateData.textColor,
                isEmailEnabled: templateData.isEmailEnabled,
                authorGroups: templateData.authorGroups,
                emailOffSet: templateData.emailOffSet,
                allowSendAll: templateData.allowSendAll,
                isIncidentSummary: templateData.isIncidentSummary,
                isPowerAutomateEnabled: templateData.isPowerAutomateEnabled,
                elements: templateData.elements,
            }
            this.setState({
                template: newTemplate
            });
        } catch (error) {
            return error;
        }
    }

    public render(): JSX.Element {
        if (this.state.loader) {
            return (
                <div className="loader">
                    <Spinner />
                </div>
            );
        } else {
            return (
                <div className="taskModule">
                    <div className="formContainer">
                        <div className="formContentContainer" >
                            <div className="contentField">
                                <h3>{this.localize("ConfirmToSend")}</h3>
                                <span>{this.localize("SendToRecipientsLabel")}</span>
                            </div>

                            <div className="results">
                                {this.renderAudienceSelection()}
                            </div>
                        </div>
                        <div className="adaptiveCardContainer">
                        </div>
                    </div>

                    <div className="footerContainer">
                        <div className="buttonContainer">
                            <Spinner id="sendingLoader" className="hiddenLoader sendingLoader" size="extra-small" label={this.localize("PreparingMessageLabel")} labelPosition="after" />
                            <Button id="sendBtn" onClick={this.onSendMessage} appearance='primary' >{this.localize("Send")}</Button>
                        </div>
                    </div>
                </div>
            );
        }
    }

    private onSendMessage = () => {
        let spanner = document.getElementsByClassName("sendingLoader");
        spanner[0].classList.remove("hiddenLoader");
        sendDraftNotification(this.state.message).then(() => {
            dialog.url.submit();
        });
    }

    private getItemList = (items: string[]): JSX.Element => (<ul className='audienceList'>
        {items.map(x => (
            <li key={x}><Persona name={x} textAlignment="center" avatar={{ color: "colorful", "aria-hidden": true }} /></li>
        ))}
    </ul>)

    private renderAudienceSelection = () => {
        let recipents: JSX.Element[] = []
        if (this.state.teamNames && this.state.teamNames.length > 0) {
            recipents.push(
                <div key="teamNames"> <span className="label">{this.localize("TeamsLabel")}</span>
                    {this.getItemList(this.state.teamNames)}
                </div>
            );
        }
        if (this.state.rosterNames && this.state.rosterNames.length > 0) {
            recipents.push(
                <div key="rosterNames"> <span className="label">{this.localize("TeamsMembersLabel")}</span>
                {this.getItemList(this.state.rosterNames)}
                </div>);
        }
        if (this.state.groupNames && this.state.groupNames.length > 0) {
            recipents.push(
                <div key="groupNames" > <span className="label">{this.localize("GroupsMembersLabel")}</span>
                {this.getItemList(this.state.groupNames)}
                </div>);
        }
        if (this.state.usersListFile || this.state.userNames && this.state.userNames.length > 0) {
            recipents.push(
                <div key="userNames" > <span className="label">{"User(s): "}</span>
                    {this.state.usersListFile && (<Link target="_blank" inline href={"/api/Content/getUsersAudience?fileName=" + this.state.usersListFile}>{this.state.usersListFile}</Link>)}
                    {this.getItemList(this.state.userNames)}
                </div>);
        }
        if (this.state.allUsers) {
            recipents.push(
                <div key="allUsers">
                    <span className="label">{this.localize("AllUsersLabel")}</span>
                    <div className="noteText">
                        <Text className='errorText'>{this.localize("SendToAllUsersNote")}</Text>
                    </div>
                </div>);
        } else {
            recipents.push(<div></div>);
        }

        return (<>{recipents}</>)
    }
}

const sendConfirmationTaskModuleWithTranslation = withTranslation()(SendConfirmationTaskModule);
export default sendConfirmationTaskModuleWithTranslation;